<template>
  <div>
    <div class="assume-leadership-div" v-if="mode == 'topbar'">
      <template>
        <div v-if="!isTeamLeader">
          <div class="hidden-xs hidden-sm inlineFlex align-items">
            <div class="inlineFlex align-items" aria-hidden="true">
              <i class="fas fa-user-circle marginRight8" aria-hidden="true"></i>
              <div class="fontBold fontSize16 paddingTop5">
                {{ getStudentName(teamLeader) }} is the reporter for
                {{ testObj.myProgression.team.name }}
              </div>
            </div>
            <button
              v-if="
                !testObj.teamsNotAllowedToUpdateTeamLeader ||
                  (testObj.teamsNotAllowedToUpdateTeamLeader &&
                    !testObj.teamsNotAllowedToUpdateTeamLeader.includes(
                      testObj.myProgression.team.uuid
                    ))
              "
              class="btn gradient btn-default subBtn textLink"
              @click.prevent="changeTeamLeader(myOwnCredentials)"
              tabindex="0"
              :aria-label="
                getStudentName(teamLeader) +
                  ' is the reporter for ' +
                  testObj.myProgression.team.name +
                  ' Take Over as Reporter button'
              "
            >
              <i class="fa fa-users marginRight8" aria-hidden="true"></i>Take over as reporter
            </button>
            <div v-else tabindex="0">
              (Teacher has disabled changing team reporter)
            </div>
          </div>

          <div class="hidden-md hidden-lg">
            <div class="inlineFlex align-items" aria-hidden="true">
              <i class="fas fa-user-circle marginRight8" aria-hidden="true"></i>
              <div class="fontBold fontSize16">
                {{ getStudentName(teamLeader) }} is the reporter for
                {{ testObj.myProgression.team.name }}
              </div>
            </div>
            <div
              v-if="
                !testObj.teamsNotAllowedToUpdateTeamLeader ||
                  (testObj.teamsNotAllowedToUpdateTeamLeader &&
                    !testObj.teamsNotAllowedToUpdateTeamLeader.includes(
                      testObj.myProgression.team.uuid
                    ))
              "
            >
              <button
                class="btn gradient btn-default subBtn textLink"
                @click.prevent="changeTeamLeader(myOwnCredentials)"
                tabindex="0"
                :aria-label="
                  getStudentName(teamLeader) +
                    ' is the reporter for ' +
                    testObj.myProgression.team.name +
                    ' Take Over as Reporter button'
                "
              >
                <i class="fa fa-users marginRight8" aria-hidden="true"></i>Take over as reporter
              </button>
            </div>
            <div v-else tabindex="0">
              (Teacher has disabled changing team reporter)
            </div>
          </div>
        </div>

        <div v-else>
          <div class="hidden-xs hidden-sm inlineFlex align-items">
            <div class="inlineFlex align-items" aria-hidden="true">
              <i class="fas fa-user-circle marginRight8" aria-hidden="true"></i>
              <div class="fontBold fontSize16 paddingTop5">
                You are the team reporter for
                {{ testObj.myProgression.team.name }}
              </div>
            </div>
            <button
              v-if="
                !testObj.teamsNotAllowedToUpdateTeamLeader ||
                  (testObj.teamsNotAllowedToUpdateTeamLeader &&
                    !testObj.teamsNotAllowedToUpdateTeamLeader.includes(
                      testObj.myProgression.team.uuid
                    ))
              "
              class="btn gradient btn-default subBtn textLink"
              @click.prevent="viewTeam()"
              tabindex="0"
              :aria-label="
                'You are the team reporter for ' +
                  testObj.myProgression.team.name +
                  ' Assign others as reporter button'
              "
            >
              <i class="fa fa-users marginRight8" aria-hidden="true"></i>Assign others as reporter
            </button>
            <div v-else tabindex="0">
              (Teacher has disabled changing team reporter)
            </div>
          </div>

          <div class="hidden-md hidden-lg">
            <div class="inlineFlex align-items" aria-hidden="true">
              <i class="fas fa-user-circle marginRight8" aria-hidden="true"></i>
              <div class="fontBold fontSize16">
                You are the team reporter for ({{
                  testObj.myProgression.team.name
                }})
              </div>
            </div>
            <button
              v-if="
                !testObj.teamsNotAllowedToUpdateTeamLeader ||
                  (testObj.teamsNotAllowedToUpdateTeamLeader &&
                    !testObj.teamsNotAllowedToUpdateTeamLeader.includes(
                      testObj.myProgression.team.uuid
                    ))
              "
              class="btn gradient btn-default subBtn textLink"
              @click.prevent="viewTeam()"
              tabindex="0"
              :aria-label="
                'You are the team reporter for ' +
                  testObj.myProgression.team.name +
                  ' Assign others as reporter button'
              "
            >
              <i class="fa fa-users marginRight8" aria-hidden="true"></i>Assign others as reporter
            </button>
            <div v-else tabindex="0">
              (Teacher has disabled changing team reporter)
            </div>
          </div>
        </div>
      </template>
    </div>
    <div
      :id="'assign_reporter_' + id"
      class="modal assign_reporter"
      style="z-index:50001!important;"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'assignReporterModal' + id + '-title'"
    >
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <div
              :id="'assignReporterModal' + id + '-title'"
              class="modal-title"
            >
              Assign Others as Reporter for
              {{ testObj.myProgression.team.name }}
            </div>
          </div>
          <div class="modal-body">
            <template v-for="student in testObj.myProgression.team.students">
              <div class="flexSpaceBetween align-items assignDiv">
                <div class="flexOnly align-items">
                  <div class="status-avatar">
                    <div
                      class="status-avatar-content"
                      :class="{
                        present: student._isPresent,
                        absent: !student._isPresent,
                      }"
                    >
                      <template v-if="student.profileURL">
                        <div class="actual-image"></div>
                      </template>
                      <template v-else>
                        {{ getStudentInitials(student) }}
                      </template>
                    </div>
                    <div
                      class="position-absolute"
                      :class="{
                        present: student._isPresent,
                        absent: !student._isPresent,
                      }"
                    >
                      <i class="fas fa-circle" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div class="fontBold">
                    {{ getStudentName(student) }}
                  </div>
                </div>
                <div
                  v-if="
                    student.uuid != testObj.myProgression.team.teamLeaderUuid
                  "
                >
                  <button
                    :disabled="!canAssignOtherTeammates"
                    class="btn btn-primary mainBtn"
                    @click="changeTeamLeader(student)"
                    :aria-label="
                      'Assign ' + getStudentName(student) + ' as team reporter'
                    "
                  >
                    Assign
                  </button>
                </div>
              </div>
            </template>
            <button
              class="col-xs-12 btn btn-default mainBtn marginTop30"
              data-dismiss="modal"
              aria-label="Back"
            >
              <i class="fa fa-caret-left marginRight8" aria-hidden="true"></i>Back
            </button>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
    <div
      :id="'you_have_been_assigned_team_leader_modal_' + id"
      class="modal"
      style="z-index:50001!important;"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'assignedAsTeamLeaderModal' + id + '-title'"
    >
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <div
              :id="'assignedAsTeamLeaderModal' + id + '-title'"
              class="modal-title"
            >
              You have been assigned as reporter
            </div>
          </div>
          <div class="modal-body">
            <div>
              You have been assigned as new reporter.
            </div>
            <button
              class="col-xs-12 btn btn-success mainBtn marginTop30"
              data-dismiss="modal"
              aria-label="Ok"
            >
              Ok
            </button>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
      <div
        :id="'teacher_has_frozen_team_leader_modal_' + id"
        class="modal"
        style="z-index:50001!important;"
        tabindex="-1"
        role="dialog"
        :aria-labelledby="'frozenTeamLeaderModal' + id + '-title'"
      >
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close Modal"
              >
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
              </button>

              <div
                :id="'frozenTeamLeaderModal' + id + '-title'"
                class="modal-title"
              >
                Teacher has frozen any changes on team reporter
              </div>
            </div>
            <div class="modal-body">
              <div>
                Teacher has frozen any changes on team reporter
              </div>
              <button
                class="col-xs-12 btn btn-success mainBtn marginTop30"
                data-dismiss="modal"
                aria-label="Ok"
              >
                Ok
              </button>
            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { testMixins } from "./../../../../../mixins/test";
import KrAuth from "../../../../../components/auth/auth";
export default {
  mixins: [testMixins],
  props: ["options"],
  created() {
    this.$emit("isTeamLeader", this.isTeamLeader);
    this.mode = _.get(this.options, "mode", "topbar");
  },
  data() {
    return {
      mode: "topbar", //topbar & stopping
      id: (+new Date()).toString(36).slice(-5),
      auth:new KrAuth()
    };
  },
  methods: {
    viewTeam() {
      $("#assign_reporter_" + this.id).modal("show");
    },
    changeTeamLeader(student) {
      var that = this;
      let oldTeamLeaderUuid = this.testObj.myProgression.team.teamLeaderUuid;
      this.testObj.myProgression.team.teamLeaderUuid = student.uuid;
      axios
        .put("/student/tests/" + this.testObj.uuid + "/update/team-leader", {
          userPlacementTestUuid: student.uuid,
        })
        .then(function(response) {
          $("#assign_reporter_" + that.id).modal("hide");
          that.$emit("isTeamLeader", that.isTeamLeader);
          if (that.isTeamLeader) {
            $("#you_have_been_assigned_team_leader_modal_" + that.id).modal(
              "show"
            );
          }
          that.$notify({
            group: "form",
            type: "success",
            title: "Success",
            text: "Team leader has been changed",
          });
        })
        .catch(function(errors) {
          $("#assign_reporter_" + that.id).modal("hide");
          that.testObj.myProgression.team.teamLeaderUuid = oldTeamLeaderUuid;
          that.$notify({
            group: "form",
            type: "error",
            title: "Error",
            text:
              "Unable to change team leader  at this time, please try again later",
          });
        });
    },
    getStudentInitials(student) {
      if (!student) {
        return "";
      }
      return (
        (student.firstname ? student.firstname.charAt(0) : "") +
        (student.lastname ? student.lastname.charAt(0) : "")
      );
    },
    getStudentName(student, limit = true) {
      if (!student) {
        return "";
      }
      var name =
        student.firstname + (student.lastname ? " " + student.lastname : "");
      if (name.length > 20 && limit) {
        return name.slice(0, 17) + "...";
      }
      return name;
    },
  },
  computed: {
    teamLeader() {
      if (
        this.testObj.type == "irat" ||
        (this.testObj.type == "application" &&
          this.testObj.others.applicationType != "team")
      ) {
        return null;
      }
      var that = this;
      return _.find(this.testObj.myProgression.team.students, function(o) {
        return o.uuid == that.testObj.myProgression.team.teamLeaderUuid;
      });
    },
    canAssignOtherTeammates(){
      return false;
    }
  },
};
</script>
<style lang="scss" scoped>
.assume-leadership-div {
  border: 1px solid #1991eb;
  border-radius: 3px;
  background: #cfe2f3;
  padding: 10px 20px;
}

span.assume-leadership {
  color: #222222;
  font-size: 14px;
  font-weight: bold;
  display: inline-block;
}
span.team-initial {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background-color: #495060;
  line-height: 26px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  display: inline-block;
  text-align: center;
}

.fas.fa-user-circle {
  font-size: 20px;
  color: #8a8a8a;
}

.assign_reporter .profile_image {
  width: 48px;
  height: 48px;
  border-radius: 30px;
  margin-right: 10px;
}

.assign_reporter .actual-image {
  width: 100%;
  height: 100%;
  background: #222;

  background-position: center;
  background-size: cover;
}

.assignDiv {
  margin-top: 30px;
}

.assignDiv:first-child {
  margin-top: 0;
}

.status-avatar {
  width: 48px;
  height: 48px;
  margin-right: 10px;
  position: relative;

  .status-avatar-content {
    width: 100%;
    height: 100%;
    background: #2a3f54;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    // -ms-mask-image: radial-gradient(
    //   circle 18px at calc(100% - 7px) calc(100% - 7px),
    //   transparent 9px,
    //   #000 0
    // );
    // -o-mask-image: radial-gradientradial-gradient(
    //   circle 18px at calc(100% - 7px) calc(100% - 7px),
    //   transparent 9px,
    //   #000 0
    // );
    // -moz-mask-image: radial-gradient(
    //   circle 18px at calc(100% - 7px) calc(100% - 7px),
    //   transparent 9px,
    //   #000 0
    // );
    // -webkit-mask-image: radial-gradient(
    //   circle 18px at calc(100% - 7px) calc(100% - 7px),
    //   transparent 9px,
    //   #000 0
    // );
    font-size: 18px;
    color: white;

    &.absent {
      opacity: 0.5;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .position-absolute {
    position: absolute;
    bottom: -2px;
    right: -5px;
    line-height: 0.8;

    &.present {
      color: #0f9b81;
    }

    &.absent {
      color: #989b9c;
    }

    .fas.fa-circle {
      border: 3px solid #fff;
      border-radius: 50%;
    }
  }
}
</style>
